"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var applyJustifyLayout = function applyJustifyLayout($select, type) {
  $select.children(type).after('&nbsp; ');
  $select.append("<".concat(type, " style=\"max-height:0;line-height: 0; font-size: 0; width: 100% !important; display: inline-block;\"></").concat(type, ">"));
};

var _default = applyJustifyLayout;
exports["default"] = _default;